export default {
    validate: {
        Auth: {
            login: {
                required: 'Это поле обьязательное'
            },
            password: {
                required: 'Это поле обьязательное',
                minLength: 'Минимальная длина пароля - 6'
            },
            server: {
                required: 'Это поле обьязательное'
            }
        },
        Address: {
            street: {
                required: 'Это поле обьязательное'
            },
            city: {
                required: 'Это поле обьязательное'
            },
            name: {
                required: 'Это поле обьязательное'
            },
            importance: {
                required: 'Это поле обьязательное'
            },
            district: {
                required: 'Это поле обьязательное'
            },
            latitude: {
                required: 'Это поле обьязательное',
                demical: 'Неверный формат'
            },
            longitude: {
                required: 'Это поле обьязательное',
                demical: 'Неверный формат'
            }
        }
    }
}